export const DEFAULT_SETTING = {
  IMAGE_WIDTH: 288,
  SWIPE_AT_ONCE: 2,
  REELCOUNT: 4,
  IMAGE_HEIGHT: 330,
  widgetContainerStyle: {
    padding: '0',
  },
  carouselStyle: {
    position: 'relative',
    padding: '0 25px',
  },
  slotStyle: {
    margin: '20px 0',
    padding: '0 20px',
  },
};

export const WIDGET_MOBILE = {
  IMAGE_WIDTH: 185,
  SWIPE_AT_ONCE: 1,
  REELCOUNT: 2,
  IMAGE_HEIGHT: 245,
  widgetContainerStyle: {
    padding: ' 0',
  },
  carouselStyle: {
    position: 'relative',
    padding: '0',
  },
  slotStyle: {
    margin: '20px 0',
    padding: '0 20px',
  },
};
